import { MetaTagsProps, SubCategory } from "@/types";
import { content } from "./content";
import { images } from "./images";
import { OG_PATH } from "@/content";
import {
  createImageItems,
  createServicePoints,
} from "@/content/services/service-content-helpers";

const slug = "intercom-systems-sydney";
const serviceId = 3;

export const createMetaTags = (
  parentMetaTags: MetaTagsProps,
): { metaTags: MetaTagsProps; slug: string } => {
  const metaTags: MetaTagsProps = {
    title: "Intercom Systems Sydney | Ozy Wide Group",
    description:
      "Audio and video intercom systems for controlled visitor access at homes, offices, gates and shared entries.",
    keywords:
      "intercom systems Sydney, video intercom, audio intercom, visitor management, door release, gate intercom, apartment intercom",
    url: `${parentMetaTags.url.replace(/\/$/, "")}/${slug}/`,
    ogImage: `${OG_PATH}service-${slug}.jpg`,
    type: "website",
  };

  return { metaTags, slug };
};

export const category: Omit<SubCategory, "headCategory" | "slug" | "metaTags"> =
  {
    id: serviceId,
    title: "Intercom Systems",
    description:
      "Audio and video intercom systems for controlled visitor access at homes, offices, gates and shared entries.",
    points: createServicePoints(
      "Visitor entry flow reviewed",
      "Audio, video and release options planned",
      "Door or gate access tested before handover",
    ),
    images: createImageItems(images, "Intercom Systems Sydney"),
    content,
  };
